import { useTranslate } from '@providers/TranslateProvider';

import { ChessBoardProps } from '@exports/ChessBoard';

import { TIME_CONTROL } from '../constants';
import { IGame } from '../types/game';

export type ISpecsGame = {
  whiteClockControlSettings?: IGame['whiteClockControlSettings'];
  blackClockControlSettings?: IGame['blackClockControlSettings'];
  clockControlType?: IGame['clockControlType'];
  tournament?: {
    timeControl?: unknown;
  };
};

export function formatGameSpecs(
  game: ISpecsGame | undefined,
  orientation: ChessBoardProps['orientation'] = 'white',
  t: ReturnType<typeof useTranslate>['t'],
) {
  const specs: string[] = [];
  const whiteClock = game?.whiteClockControlSettings;
  const blackClock = game?.blackClockControlSettings;
  const areClocksIdentical =
    whiteClock &&
    blackClock &&
    whiteClock.initialSeconds === blackClock.initialSeconds &&
    whiteClock.addSecondsPerMove === blackClock.addSecondsPerMove;

  const playerTopClock = orientation === 'white' ? blackClock : whiteClock;
  const playerBottomClock = orientation === 'white' ? whiteClock : blackClock;

  const timeControl =
    game?.clockControlType ??
    (game?.tournament?.timeControl as IGame['clockControlType'] | undefined);

  if (timeControl && TIME_CONTROL[timeControl]) {
    specs.push(t(TIME_CONTROL[timeControl]!));
  }

  if (playerTopClock) {
    specs.push(
      `${Math.floor(playerTopClock.initialSeconds / 60)}'+${playerTopClock.addSecondsPerMove}"`,
    );
  }

  if (playerBottomClock && !areClocksIdentical) {
    specs.push(
      `${Math.floor(playerBottomClock.initialSeconds / 60)}'+${playerBottomClock.addSecondsPerMove}"`,
    );
  }

  return specs;
}
